import type { BoolQuery, QueryClause } from '../types/query'

export type BoolInput = {
	filter?: Array<QueryClause>
	must?: Array<QueryClause>
	must_not?: Array<QueryClause>
	should?: Array<QueryClause>
	minimumShouldMatch?: number
}

/**
 * Build a `bool` query, omitting empty arrays so the JSON stays tight.
 */
export function createBoolQuery(input: BoolInput): BoolQuery {
	const bool: BoolQuery['bool'] = {}

	if (input.filter && input.filter.length > 0) bool.filter = input.filter
	if (input.must && input.must.length > 0) bool.must = input.must
	if (input.must_not && input.must_not.length > 0)
		bool.must_not = input.must_not
	if (input.should && input.should.length > 0) {
		bool.should = input.should
		if (input.minimumShouldMatch !== undefined) {
			bool.minimum_should_match = input.minimumShouldMatch
		}
	}

	return { bool }
}
